import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  searchUserText: '',
  recordsPerPage: 10,
  pageNumber: 1,
  claimNumbersList: [],
};

export const uploadDocumentSlice = createSlice({
  name: 'uploadDocument',
  initialState: INITIAL_STATE,
  reducers: {
    setSearchUserText: (state, action) => {
      state.searchUserText = action.payload;
    },
    setRecordsPerPage: (state, action) => {
      state.recordsPerPage = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setClaimNumbersList: (state, action) => {
      state.claimNumbersList = action.payload;
    },

    resetUploadDocuments: (state, action) => {
      state.searchUserText = INITIAL_STATE.searchUserText;
      state.recordsPerPage = INITIAL_STATE.recordsPerPage;
      state.pageNumber = INITIAL_STATE.pageNumber;
      state.claimNumbersList = INITIAL_STATE.claimNumbersList;
    },
  },
});

export const {
  setSearchUserText,
  setRecordsPerPage,
  setPageNumber,
  resetUploadDocuments,
  setClaimNumbersList,
} = uploadDocumentSlice.actions;

export default uploadDocumentSlice.reducer;
